import { useState, useEffect } from 'react'
import { getPhonesAPI } from '../services/phones'

function UsePhone() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getPhonesAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.phone_packet, p_amount: d.p_amount }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UsePhone
